import React, { Component } from "react";
import "./index.css";
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import { BsyUtils } from "../../utils/Utils";
import BsyDashboardMenu from "../dashboard/BsyDashboardMenu";
import { withRouter } from "react-router-dom";
import BsyDialog from "../BsyDialog";
import BsyMaskLayer from "../BsyMaskLayer";
import BsySLoading from "../BsySLoading";

class BsyAppStore extends Component {
  state = {
    list: [],
    menuId: "",
    headerTitle: "",
    headerDesc: "",
    searchContShow: false,
    searchAppList: [],
    searchMenuList: [],
    searchMenuId: 0,
    childrenMenuId: 0,
    appNum: null,
    step: 1,
    apps: [],
  };
  searchValue = React.createRef();
  searchValues = React.createRef();

  componentDidMount() {
    React.axios("/bbymember/tpl_list")
      .then((res) => {
        React.axios("/dashboard/app_group/list").then((res1) => {
          let appNum = 0;
          res1.data.items.map((res2) => {
            appNum += res2.appcount;
            return null;
          });
          if (res.data.list.length <= 0) {
            this.setState(
              {
                list: [],
                headerTitle: "",
                headerDesc: "",
                menuId: res.data.list.length > 0 ? res.data.list[0].id : "",
                apps: res1.data.items,
                appNum,
              },
              () => {
                if (window.location.href.includes("to=create")) {
                  this.toApp();
                }
              }
            );
          } else {
            this.setState(
              {
                apps: res1.data.items,
                list: res.data.list,
                headerTitle: res.data.list[0].title,
                headerDesc: res.data.list[0].headerDesc,
                menuId: res.data.list.length > 0 ? res.data.list[0].id : "",
                appNum,
              },
              () => {
                if (window.location.href.includes("to=create")) {
                  this.toApp();
                }
              }
            );
          }
        });
      })
      .catch((res) => {
        console.error(res);
      });
    this.searchValue.current.addEventListener("keyup", (event) => {
      if (event.keyCode === 13) {
        this.searchValue.current.parentNode.children[1].style.color = "#0265FF";
        setTimeout(() => {
          this.searchValue.current.parentNode.children[1].style.color =
            "#666666";
        }, 218);
        this.searchMenuEnter(true);
        this.searchValues.current && (this.searchValues.current.value = "");
      }
    });

    this.searchValues.current &&
      this.searchValues.current.addEventListener("keyup", (event) => {
        if (event.keyCode === 13) {
          this.searchValues.current.parentNode.children[1].style.color =
            "#0265FF";
          setTimeout(() => {
            this.searchValues.current.parentNode.children[1].style.color =
              "#666666";
          }, 218);
          this.searchMenuEnter(false);
          this.searchValue.current && (this.searchValue.current.value = "");
        }
      });
  }

  _installApp = (data, cb) => {
    const i = this;
    const { apps } = this.state;
    let n = window.FX.Utils.createLoadLayer(window.$("body"), {
      isLight: !0,
      hasLoader: !0,
    });
    React.axios("/bbymember/tpl_install", {
      ...data,
    })
      .then((res) => {
        n.remove();
        if (res.data.code === 200) {
          if (document.body.offsetWidth <= 1200) {
            window.FX.Utils.redirectTo("/team/app/" + res.data.data.strappid);
          } else {
            window.FX.Utils.redirectTo("/team/app/" + res.data.data.strappid);
          }
        } else {
          tipAlert({
            type: "warning",
            msg: res.data.msg,
          });
        }
        cb && cb();
      })
      .catch((res) => {
        n.remove();
        if (res.state == 400) {
          tipAlert({
            type: "error",
            msg: res.data.msg,
          });
        }
      });
  };

  createApp = () => {
    const _this = this;
    const n = window.$('<div class="app-ref-copy-content">');
    React.axios("/dashboard/app_group/list")
      .then((res) => {
        let a = new window.FX.AppInstallGroup({
          renderEl: n,
          groups: res.data.items,
        });
        let copyDialog = new window.FX.ConfirmDialog({
          title: React.language("template.install.toGroup"),
          width: 450,
          height: 390,
          onContentCreate: function (e) {
            e.append(n);
          },
          onOk: function () {
            var toappid = a.getValue();
            _this._installApp({
              mode: "blank",
              groupid: toappid.groupId,
            });
            copyDialog.close();
          },
        });
        copyDialog.show();
      })
      .catch((res) => {});
  };

  switchMenu = (val) => {
    return (event) => {
      event.target.parentNode.getElementsByClassName("active")[0] &&
        event.target.parentNode
          .getElementsByClassName("active")[0]
          .classList.remove("active");
      event.target.classList.add("active");
      this.setState({
        menuId: val.id,
        childrenMenuId: 0,
        searchContShow: false,
        headerTitle: val.title,
        headerDesc: val.desc,
      });
      if (
        event.currentTarget.parentNode.parentNode.parentNode.parentNode
          .classList.length === 2
      ) {
        event.currentTarget.parentNode.parentNode.parentNode.parentNode.classList.remove(
          "open"
        );
        if (document.body.offsetWidth <= 1200) {
          setTimeout(() => {
            document.getElementsByClassName("left-box")[0].style.display =
              "none";
          }, 300);
        }
      } else {
        event.currentTarget.parentNode.parentNode.parentNode.parentNode.classList.add(
          "open"
        );
        if (document.body.offsetWidth <= 1200) {
          document.getElementsByClassName("left-box")[0].style.display =
            "block";
        }
      }
    };
  };

  childrenMenuSwitch = (id) => {
    return (event) => {
      event.target.parentNode.getElementsByClassName("active")[0] &&
        event.target.parentNode
          .getElementsByClassName("active")[0]
          .classList.remove("active");
      event.target.classList.add("active");
      this.setState({ childrenMenuId: id, searchContShow: false });
    };
  };

  previewSkip = (url) => {
    return (event) => {
      event.stopPropagation();
      BsyUtils.redirectTo(url, "_blank");
    };
  };

  installApp = (id) => {
    return (event) => {
      event.stopPropagation();
      const _this = this;
      const n = window.$('<div class="app-ref-copy-content">');
      if (id.tpl_type === "bsy") {
        React.axios("/dashboard/app_group/list")
          .then((res) => {
            let a = new window.FX.AppInstallGroup({
              renderEl: n,
              groups: res.data.items,
            });
            let copyDialog;
            let importdata = true;
            copyDialog = new window.FX.ConfirmDialog({
              title: React.language("template.install.toGroup"),
              width: document.body.offsetWidth <= 1200 ? 330 : 450,
              height: 390,
              text4Cancel: null,
              onContentCreate: function (e) {
                e.append(n);
                new window.FX.CheckBox({
                  renderEl: window
                    .$('<div style="margin-left: 20px;margin-top: 10px;" />')
                    .appendTo(e),
                  value: importdata,
                  onStateChange: function (ed) {
                    importdata = ed;
                  },
                  text: React.language("import.package.group.tip"),
                });
              },
              onOk: function () {
                var toappid = a.getValue();
                _this._installApp({
                  mode: "tpl",
                  tpl_id: id.id,
                  groupid: toappid.groupId,
                  sampledata: importdata,
                });
                copyDialog.close();
              },
            });
            copyDialog.show();
          })
          .catch((res) => {});
        return;
      } else {
        React.axios("/dashboard/tpl_install_check", {
          tpl_id: id.id,
        })
          .then((res) => {
            if (res.data.code === 200) {
              if (res.data.needGroup) {
                React.axios("/dashboard/app_group/list")
                  .then((res) => {
                    let a = new window.FX.AppInstallGroup({
                      renderEl: n,
                      groups: res.data.items,
                    });
                    let copyDialog;
                    let importdata = true;
                    copyDialog = new window.FX.ConfirmDialog({
                      title: React.language("template.install.toGroup"),
                      width: document.body.offsetWidth <= 1200 ? 330 : 450,
                      height: 390,
                      onContentCreate: function (e) {
                        e.append(n);
                        new window.FX.CheckBox({
                          renderEl: window
                            .$(
                              '<div style="margin-left: 20px;margin-top: 10px;" />'
                            )
                            .appendTo(e),
                          value: importdata,
                          onStateChange: function (ed) {
                            importdata = ed;
                          },
                          text: React.language("import.package.group.tip"),
                        });
                      },
                      onOk: function () {
                        var toappid = a.getValue();
                        _this._installApp({
                          mode: "tpl",
                          tpl_id: id.id,
                          groupid: toappid.groupId,
                          sampledata: importdata,
                        });
                        copyDialog.close();
                      },
                    });
                    copyDialog.show();
                  })
                  .catch((res) => {});
              } else {
                let copyDialog;
                let importdata = true;
                copyDialog = new window.FX.ConfirmDialog({
                  title: React.language("template.install"),
                  width: document.body.offsetWidth <= 1200 ? 330 : 450,
                  height: 150,
                  onContentCreate: function (e) {
                    // e.append(n);
                    new window.FX.CheckBox({
                      renderEl: window
                        .$(
                          '<div style="margin-left: 20px;margin-top: 10px;" />'
                        )
                        .appendTo(e),
                      value: importdata,
                      onStateChange: function (ed) {
                        importdata = ed;
                      },
                      text: React.language("import.package.group.tip"),
                    });
                  },
                  onOk: function () {
                    // var toappid = a.getValue();
                    _this._installApp({
                      mode: "tpl",
                      tpl_id: id.id,
                      groupid: "original",
                      sampledata: importdata,
                    });
                    copyDialog.close();
                  },
                });
                copyDialog.show();
              }
            } else {
              tipAlert({
                type: "warning",
                msg: res.data.msg,
              });
            }
          })
          .catch((res) => {});
      }
    };
  };

  switchSearchMenu = (val) => {
    return (event) => {
      document.getElementById("menu-" + val.id).classList.add("active");
      this.setState({
        menuId: val.id,
        childrenMenuId: 0,
        searchContShow: false,
        headerTitle: val.title,
        headerDesc: val.desc,
      });
    };
  };

  RemoveValByIndex = (arr, index, length) => {
    var reg = new RegExp(index, "g");
    return arr.replace(reg, length);
  };

  searchMenuEnter = (isOpen) => {
    const { list } = this.state;
    const applist = JSON.parse(JSON.stringify(list));
    const appMenulist = JSON.parse(JSON.stringify(list));
    const searchValue = isOpen
      ? this.searchValue.current.value
      : this.searchValues.current.value;
    if (isOpen) {
      this.searchValues.current && (this.searchValues.current.value = "");
    }
    const searchList = [];
    const searchMenuList = [];
    if (!searchValue) {
      tipAlert({
        type: "warning",
        msg: React.language("app.store.search.empty"),
      });
      return;
    }
    applist.forEach((val) => {
      let flag = false;
      val.childs.forEach((val1) => {
        let tpl_list = [];
        val1.tpl_list.forEach((val2) => {
          val1.tpl_list = [];
          if (val2.title.indexOf(searchValue) > -1) {
            tpl_list.push(val2);
            val2.titleHtml = this.RemoveValByIndex(
              val2.title,
              searchValue,
              "<span>" + searchValue + "</span>"
            );
            flag = true;
          }
        });
        if (flag) {
          val1.tpl_list = tpl_list;
        }
      });
      if (flag) {
        searchList.push(val);
      }
    });

    appMenulist.map((val) => {
      if (val.title.indexOf(searchValue) > -1) {
        searchMenuList.push(val);
      }
      return false;
    });
    document.getElementById("menu-list").getElementsByClassName("active")[0] &&
      document
        .getElementById("menu-list")
        .getElementsByClassName("active")[0]
        .classList.remove("active");

    if (searchList.length <= 0 && searchMenuList.length <= 0) {
      tipAlert({
        type: "warning",
        msg: React.language("field.location.empty"),
      });
    } else {
      this.setState({
        searchContShow: true,
        searchAppList: searchList,
        searchMenuList,
        headerTitle: React.language("app.store.search.title"),
        headerDesc: "",
      });
    }

    if (isOpen) {
      if (
        document.getElementsByClassName("app-store-list")[0].classList
          .length === 2
      ) {
        document
          .getElementsByClassName("app-store-list")[0]
          .classList.remove("open");
        if (document.body.offsetWidth <= 1200) {
          setTimeout(() => {
            document.getElementsByClassName("left-box")[0].style.display =
              "none";
          }, 300);
        }
      } else {
        document
          .getElementsByClassName("app-store-list")[0]
          .classList.add("open");
        if (document.body.offsetWidth <= 1200) {
          document.getElementsByClassName("left-box")[0].style.display =
            "block";
        }
      }
    }
    this.searchValue.current.blur();
    this.searchValues.current && this.searchValues.current.blur();
  };

  searchMenu = (isOpen) => {
    return () => {
      this.searchMenuEnter(isOpen);
    };
  };

  showMenu = (event) => {
    if (event.currentTarget.parentNode.classList.length === 2) {
      event.currentTarget.parentNode.classList.remove("open");
      if (document.body.offsetWidth <= 1200) {
        setTimeout(() => {
          document.getElementsByClassName("left-box")[0].style.display = "none";
        }, 300);
      }
    } else {
      event.currentTarget.parentNode.classList.add("open");
      if (document.body.offsetWidth <= 1200) {
        document.getElementsByClassName("left-box")[0].style.display = "block";
      }
    }
  };

  openMenu = (event) => {
    if (event.currentTarget.parentNode.parentNode.classList.length === 2) {
      event.currentTarget.parentNode.parentNode.classList.remove("open");
      if (document.body.offsetWidth <= 1200) {
        setTimeout(() => {
          document.getElementsByClassName("left-box")[0].style.display = "none";
        }, 300);
      }
    } else {
      event.currentTarget.parentNode.parentNode.classList.add("open");
      if (document.body.offsetWidth <= 1200) {
        document.getElementsByClassName("left-box")[0].style.display = "block";
      }
    }
  };

  closeMenu = () => {
    if (
      document.getElementsByClassName("app-store-list")[0].classList.length ===
      2
    ) {
      document
        .getElementsByClassName("app-store-list")[0]
        .classList.remove("open");
      if (document.body.offsetWidth <= 1200) {
        setTimeout(() => {
          document.getElementsByClassName("left-box")[0].style.display = "none";
        }, 300);
      }
    } else {
      document
        .getElementsByClassName("app-store-list")[0]
        .classList.add("open");
      if (document.body.offsetWidth <= 1200) {
        document.getElementsByClassName("left-box")[0].style.display = "block";
      }
    }
  };

  dashboardMenuCenterMenu = () => {
    return (
      <div className="header-title">{React.language("template.install")}</div>
    );
  };

  leftTitle = () => {
    return (
      <div className="leftTitle">
        <span>{React.language("nav.appstore")}</span>
      </div>
    );
  };

  toApp = () => {
    this.setState({ step: 3 });
    // document.getElementsByClassName("appStoreCont")[0].scrollTop = 166;
    document.getElementsByClassName("appStoreCont")[0].scrollTo({
      top: 166, // 滚动到的位置
      behavior: 'smooth' // 平滑滚动
    });
  };

  guideStep = (step) => {
    return () => {
      this.setState({ step });
    };
  };

  standardAppGroupId = "";

  selectAppGroupId = (id) => {
    return (e) => {
      e.currentTarget.parentNode
        .getElementsByClassName("select")[0]
        .classList.remove("select");
      e.currentTarget.classList.add("select");
      this.standardAppGroupId = id;
    };
  };

  selectAppGroup = (t, cd) => {
    BsyDialog({
      title: React.language("template.install.toGroup"),
      width: 460,
      height: 487,
      noFooter: false,
      okText: React.language("ok"),
      cancelText: React.language("cancel"),
      onContentCreate: () => {
        const { apps } = this.state;
        return (
          <div className="selectAppGroupPane">
            <div className="selectAppGroup-title">
              {React.language("template.install.target.group")}
            </div>
            <div className="selectAppGroup-content">
              {apps.map((res, key) => {
                if (key === 0) {
                  this.standardAppGroupId = res._id;
                }
                return (
                  <div
                    className={`appItems ${key === 0 ? "select" : ""}`}
                    key={res._id}
                    onClick={this.selectAppGroupId(res._id)}
                  >
                    <span
                      style={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                      title={res.name}
                    >
                      {res.name}
                    </span>
                    <i className="icon-bsy-check3"></i>
                  </div>
                );
              })}
            </div>
          </div>
        );
      },
      onOk: () => {
        let load = window.FX.Utils.createLoadLayer("body", {
          isLight: !0,
          hasLoader: !0,
        });
        if (cd) {
          cd(this.standardAppGroupId);
          load && load.remove();
          return;
        }
        React.axios(
          t
            ? `/dashboard/app/${this.selectAppContext.selectStandardAppId}/copy_standard`
            : "/bbymember/tpl_install",
          {
            mode: "standard",
            groupid: this.standardAppGroupId,
          }
        )
          .then((res) => {
            load && load.remove();
            this._fetchAppList();
          })
          .catch((res) => {
            load && load.remove();
          });
      },
    });
  };

  openImportAppPane = () => {
    const $ = window.$;
    const FX = window.FX;
    const { apps } = this.state;
    let i = this;
    let _this = this;
    let uploadel = $(
      '<div class="app-upload-content" style="position: absolute;left: 20px;right: 20px;margin-left: 0;">'
    );
    let uploadobj = new FX.ImportBby({
      renderEl: uploadel,
      maxLimitTip: React.language("installation.package.size.exceeds"),
      maxFileSize: 1024 * 1024 * 50,
      accept: ".bsys, .bsy",
      subtitle: "(.bsys和.bsy后缀的文件)",
      onChange: function (e) {
        _this.copyDialog.element
          .find(".ImportBbyName")
          .text(React.language("selected.it", { name: e[0].name }));
      },
    });
    let sampledata = false;
    this.copyDialog = new FX.ConfirmDialog({
      title: React.language("app.batch.import"),
      subTitle: React.language("app.batch.import.subtitle"),
      width: 460,
      height: 280,
      style4Header: "center",
      onContentCreate: function (e) {
        let content = $(
          '<div style="position: absolute;top: 20px;bottom: 62px;left: 0;right: 0;padding:0 20px; border-bottom: solid 1px #e0e0e0;" />'
        );
        content.append(uploadel);
        content.append(
          $(
            "<div class='ImportBbyName' style='position: absolute;top: 34px;left: 0;margin-left: 20px;' />"
          ).text("")
        );
        content.append(
          $("<div class='split-title' />")
            .css({
              marginTop: "66px",
              width: "60px",
              height: "20px",
              fontSize: "14px",
              fontWeight: "bold",
              color: "#333333",
              lineHeight: "20px",
            })
            .text(React.language("app.batch.import.set"))
        );
        new FX.CheckBox({
          renderEl: $('<div class="split-title-set" />')
            .css({
              marginTop: "12px",
            })
            .appendTo(content),
          text: React.language("import.package.group.tip"),
          onStateChange: function () {
            sampledata = this.getValue();
          },
        });
        content.appendTo(e);
      },
      onOk: function () {
        let file = uploadobj.getValue();
        if (file === "") {
          tipAlert({
            type: "warning",
            msg: React.language("select.file"),
          });
        } else {
          file.append("sampledata", sampledata);

          _this.copyDialog.close();
          _this.copyDialog = null;
          let f = file.get("file");
          _this.checkDoc(file, f.name.indexOf(".bsys") > -1 ? "bsys" : "bsy");

          // if (f.name.indexOf(".bsys") > -1) {
          //   FX.Msg.notice({
          //     title: React.language("app.batch.import.tip"),
          //     type: "async",
          //     duration: 0,
          //     content: React.language("member.async.start.tip")
          //   })

          //   $('.btn-status').text(React.language("app.batch.import.tip"));

          //   React.axios("/dashboard/app_group/list").then(res1 => {
          //     const appNewList1 = [];
          //     res1.data.items.map(item => {
          //       item.apps.map(app => {
          //         appNewList1.push(app._id);
          //       })
          //     })
          //     FX.Utils.ajaxUpload({
          //       url: '/dashboard/importbby_batch',
          //       data: file
          //     }, function (d) {
          //       FX.Msg.notice({
          //         title: d.msg || d.info,
          //         type: "success",
          //         duration: 0,
          //       })
          //       React.axios("/dashboard/app_group/list").then(res => {
          //         const storeAppOldList = appNewList1;
          //         const appOldList = appNewList1;
          //         const appNewList = [];
          //         if (!storeAppOldList) {
          //           apps.map(item => {
          //             item.apps.map(app => {
          //               appOldList.push(app._id);
          //             })
          //           })
          //         } else if (storeAppOldList && storeAppOldList.length === 0) {
          //           apps.map(item => {
          //             item.apps.map(app => {
          //               appOldList.push(app._id);
          //             })
          //           })
          //         }
          //         res.data.items.map(item => {
          //           item.apps.map(app => {
          //             if (appOldList.indexOf(app._id) < 0) {
          //               appNewList.push(app._id);
          //             }
          //           })
          //         })
          //         BsyUtils.Store.set("appNewList", appNewList);
          //         i.props.history.push("/team/apps");
          //       })
          //     }, null, function (d) {

          //       if (copyDialog) {
          //         copyDialog.close();
          //         copyDialog = null;
          //       }
          //       d.responseJSON && FX.Msg.notice({
          //         title: d.responseJSON.msg,
          //         type: "error",
          //         duration: 0,
          //       })
          //     });
          //   })

          // } else if (f.name.indexOf(".bsy") > -1) {
          //   i.selectAppGroup(false, (id) => {
          //     FX.Msg.notice({
          //       title: React.language("app.batch.import.tip"),
          //       type: "async",
          //       duration: 0,
          //       content: React.language("member.async.start.tip")
          //     })
          //     file.append('groupid', id)
          //     $('.btn-status').text(React.language("app.batch.import.tip"));
          //     React.axios("/dashboard/app_group/list").then(res1 => {
          //       const appNewList1 = [];
          //       res1.data.items.map(item => {
          //         item.apps.map(app => {
          //           appNewList1.push(app._id);
          //         })
          //       })
          //       FX.Utils.ajaxUpload({
          //         url: '/dashboard/importbby',
          //         data: file
          //       }, function (d) {
          //         FX.Msg.notice({
          //           title: d.msg || d.info,
          //           type: "success",
          //           duration: 0,
          //         });

          //         React.axios("/dashboard/app_group/list").then(res => {
          //           const storeAppOldList = appNewList1;
          //           const appOldList = appNewList1;
          //           const appNewList = [];
          //           if (!storeAppOldList) {
          //             apps.map(item => {
          //               item.apps.map(app => {
          //                 appOldList.push(app._id);
          //               })
          //             })
          //           } else if (storeAppOldList && storeAppOldList.length === 0) {
          //             apps.map(item => {
          //               item.apps.map(app => {
          //                 appOldList.push(app._id);
          //               })
          //             })
          //           }
          //           res.data.items.map(item => {
          //             item.apps.map(app => {
          //               if (appOldList.indexOf(app._id) < 0) {
          //                 appNewList.push(app._id);
          //               }
          //             })
          //           })
          //           BsyUtils.Store.set("appNewList", appNewList);
          //           i.props.history.push("/team/apps");
          //         })
          //       }, null, function (d) {

          //         if (copyDialog) {
          //           copyDialog.close();
          //           copyDialog = null;
          //         }

          //         d.responseJSON && FX.Msg.notice({
          //           title: d.responseJSON.msg,
          //           type: "error",
          //           duration: 0,
          //         })
          //       });
          //     })
          //   });
          // }
        }
      },
    });
    this.copyDialog.show();
  };

  importApp = (file, type, needGroup) => {
    let _this = this;
    const { apps } = this.state;

    function installApp(groupId) {
      window.FX.Msg.notice({
        title: React.language("app.batch.import.tip"),
        type: "async",
        duration: 0,
        content: React.language("member.async.start.tip"),
      });
      if (groupId) {
        file.append("groupid", groupId);
      }

      window.$(".btn-status").text(React.language("app.batch.import.tip"));

      React.axios("/dashboard/app_group/list").then((res1) => {
        const appNewList1 = [];
        res1.data.items.map((item) => {
          item.apps.map((app) => {
            appNewList1.push(app._id);
            return null;
          });
          return null;
        });
        window.FX.Utils.ajaxUpload(
          {
            url: "/dashboard/importbby_batch",
            data: file,
          },
          function (d) {
            window.FX.Msg.notice({
              title: d.msg || d.info,
              type: "success",
              duration: 0,
            });
            React.axios("/dashboard/app_group/list").then((res) => {
              const storeAppOldList = appNewList1;
              const appOldList = appNewList1;
              const appNewList = [];
              if (!storeAppOldList) {
                apps.map((item) => {
                  item.apps.map((app) => {
                    appOldList.push(app._id);
                  });
                });
              } else if (storeAppOldList && storeAppOldList.length === 0) {
                apps.map((item) => {
                  item.apps.map((app) => {
                    appOldList.push(app._id);
                  });
                });
              }
              res.data.items.map((item) => {
                item.apps.map((app) => {
                  if (appOldList.indexOf(app._id) < 0) {
                    appNewList.push(app._id);
                  }
                });
              });
              BsyUtils.Store.set("appNewList", appNewList);
              _this.props.history.push("/team");
            });
          },
          null,
          function (d) {
            if (_this.copyDialog) {
              _this.copyDialog.close();
              _this.copyDialog = null;
            }
            d.responseJSON &&
              window.FX.Msg.notice({
                title: d.responseJSON.msg,
                type: "error",
                duration: 0,
              });
          }
        );
      });
    }

    if (type === "bsys") {
      if (needGroup) {
        _this.selectAppGroup(false, (id) => {
          installApp(id);
        });
      } else {
        installApp();
      }
    } else if (type === "bsy") {
      _this.selectAppGroup(false, (id) => {
        window.FX.Msg.notice({
          title: React.language("app.batch.import.tip"),
          type: "async",
          duration: 0,
          content: React.language("member.async.start.tip"),
        });
        file.append("groupid", id);
        window.$(".btn-status").text(React.language("app.batch.import.tip"));
        React.axios("/dashboard/app_group/list").then((res1) => {
          const appNewList1 = [];
          res1.data.items.map((item) => {
            item.apps.map((app) => {
              appNewList1.push(app._id);
            });
          });
          window.FX.Utils.ajaxUpload(
            {
              url: "/dashboard/importbby",
              data: file,
            },
            function (d) {
              window.FX.Msg.notice({
                title: d.msg || d.info,
                type: "success",
                duration: 0,
              });

              React.axios("/dashboard/app_group/list").then((res) => {
                const storeAppOldList = appNewList1;
                const appOldList = appNewList1;
                const appNewList = [];
                if (!storeAppOldList) {
                  apps.map((item) => {
                    item.apps.map((app) => {
                      appOldList.push(app._id);
                    });
                  });
                } else if (storeAppOldList && storeAppOldList.length === 0) {
                  apps.map((item) => {
                    item.apps.map((app) => {
                      appOldList.push(app._id);
                    });
                  });
                }
                res.data.items.map((item) => {
                  item.apps.map((app) => {
                    if (appOldList.indexOf(app._id) < 0) {
                      appNewList.push(app._id);
                    }
                  });
                });
                BsyUtils.Store.set("appNewList", appNewList);
                _this.props.history.push("/team");
              });
            },
            null,
            function (d) {
              if (_this.copyDialog) {
                _this.copyDialog.close();
                _this.copyDialog = null;
              }

              d.responseJSON &&
                window.FX.Msg.notice({
                  title: d.responseJSON.msg,
                  type: "error",
                  duration: 0,
                });
            }
          );
        });
      });
    }
  };

  // 检测安装说明文档是否存在
  checkDoc = (data, type) => {
    if (type !== "bsys") {
      this.importApp(data, type);
      return;
    }
    let layerRef = null;
    BsyMaskLayer({
      customCls: "sloading",
      onContentCreate: (ref) => {
        layerRef = ref;
        return <BsySLoading />;
      },
    });
    let _this = this;
    window.FX.Utils.ajaxUpload(
      {
        url: "/dashboard/check_install_tip",
        data: data,
      },
      function (d) {
        layerRef && layerRef.close();
        if (d.code === 200) {
          if (d.install_tip) {
            BsyDialog({
              title: React.language("installation.notes"),
              height: 577,
              width: 956,
              okText: React.language("app.install"),
              cancelText: React.language("cancel"),
              onContentCreate: () => {
                return (
                  <div
                    style={{
                      whiteSpace: "pre-wrap",
                      padding: 20,
                      height: "100%",
                      overflow: "auto",
                      margin: "0 20px",
                      background: "#efefef",
                    }}
                  >
                    {d.install_tip}
                  </div>
                );
              },
              onOk: () => {
                _this.importApp(data, type, d.needGroup);
              },
            });
          } else {
            _this.importApp(data, type, d.needGroup);
          }
        } else {
          tipAlert({
            type: "warning",
            msg: d.msg,
          });
        }
      },
      null,
      function (d) {
        layerRef && layerRef.close();
        d.responseJSON &&
          tipAlert({
            title: d.responseJSON.msg,
            type: "warning",
          });
      }
    );

    // React.axios("/dashboard/check_install_tip", data).then(res => {
    //   const { data: resdata } = res;
    //   if (resdata.data.code === 200) {
    //     if (resdata.data.install_tip) {
    //       tipAlert({
    //         type: "warning",
    //         msg: resdata.data.msg || data.data.info
    //       })
    //     } else {
    //       this.importApp(data, type);
    //     }
    //   } else {
    //     tipAlert({
    //       type: "warning",
    //       msg: resdata.msg || resdata.info
    //     })
    //   }
    // })
  };

  render() {
    const {
      list,
      menuId,
      childrenMenuId,
      searchContShow,
      searchAppList,
      searchMenuId,
      searchMenuList,
      headerTitle,
      headerDesc,
      appNum,
      step,
    } = this.state;
    return (
      <div className="BsyAppStore">
        {document.body.offsetWidth >= 1000 && (
          <BsyDashboardMenu
            dashboardMenuCenterMenu={this.dashboardMenuCenterMenu}
            leftTitle={this.leftTitle}
          />
        )}
        <div className="appStoreCont">
          <div className="app-create">
            <div className="app-blank app-create-item" onClick={this.createApp}>
              <div
                className="background"
                style={{
                  backgroundImage:
                    "url(" +
                    window.rootDirectroy +
                    "/template/formreport/static/css/resources/images/blueBG.png)",
                }}
              >
                <span>{React.language("app.create.empty")}</span>
              </div>
            </div>
            <div className="app-custom app-create-item" onClick={this.toApp}>
              <div
                className="background"
                style={{
                  backgroundImage:
                    "url(" +
                    window.rootDirectroy +
                    "/template/formreport/static/css/resources/images/greenBG.png)",
                }}
              >
                <span>{React.language("select.app.module")}</span>
              </div>
            </div>
            <div
              className="app-template app-create-item"
              onClick={this.openImportAppPane}
            >
              <div
                className="background"
                style={{
                  backgroundImage:
                    "url(" +
                    window.rootDirectroy +
                    "/template/formreport/static/css/resources/images/orangeBG.png)",
                }}
              >
                <span>{React.language("Import.installation.package")}</span>
              </div>
            </div>
          </div>
          <div className="app-store-list">
            <div className="header-box">
              <div className="search-box">
                <input
                  id="search-input"
                  ref={this.searchValues}
                  type="text"
                  placeholder={React.language("app.store.search")}
                />
                <i
                  className="icon-bsy-reportmenu-0"
                  onClick={this.searchMenu(false)}
                />
              </div>
              <i className="bs-icon-iconcaidanshouqi" onClick={this.openMenu} />
            </div>
            <div className="app-list-title">
              <h2>{headerTitle}</h2>
              <p>{headerDesc}</p>
            </div>
            <div className="left-box">
              <div className="mobile-menu-btn" onClick={this.showMenu}>
                <i className="bs-icon-iconcaidanshouqi" />
              </div>
              <div className="search-box">
                <input
                  id="search-input"
                  ref={this.searchValue}
                  type="text"
                  placeholder={React.language("app.store.search")}
                />
                <i
                  className="icon-bsy-reportmenu-0"
                  onClick={this.searchMenu(true)}
                />
              </div>
              <div className="menu-box">
                <ul id="menu-list">
                  {list.length > 0 &&
                    list.map((val, key) => {
                      return (
                        <li
                          id={"menu-" + val.id}
                          onClick={this.switchMenu(val)}
                          className={key === 0 ? "active" : ""}
                        >
                          {val.title}
                        </li>
                      );
                    })}
                </ul>
                <ul id="search-list"></ul>
              </div>
            </div>
            <div className="right-box">
              {searchContShow ? (
                <div className="search-cont">
                  {searchMenuList.length > 0 && (
                    <div className="searchMenu">
                      <ul>
                        {searchMenuList.map((val) => {
                          return (
                            <li onClick={this.switchSearchMenu(val)}>
                              <p>{val.title}</p>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  )}
                  <div className="searchAppList">
                    <ul>
                      {searchAppList.map((val) => {
                        return val.childs.map((val1) => {
                          return searchMenuId === 0
                            ? val1.tpl_list.map((val2) => {
                                return (
                                  <li>
                                    <div
                                      className="itemLi"
                                      onClick={this.installApp(val2)}
                                    >
                                      <div className="textBox">
                                        <div className="titleCont">
                                          <div className="titleApp">
                                            <div
                                              className={
                                                "icon-backgroup color-cover-" +
                                                val2.icon.style_color
                                              }
                                            >
                                              <div
                                                className={
                                                  "imgbg-bby-app imgbg-bby-app-" +
                                                  val2.icon.style_icon
                                                }
                                              />
                                            </div>
                                            <h2
                                              title={val2.title}
                                              dangerouslySetInnerHTML={{
                                                __html: val2.titleHtml,
                                              }}
                                            />
                                          </div>
                                          <div
                                            className="menuSkip"
                                            onClick={this.switchSearchMenu(val)}
                                          >
                                            <span>{val.title}</span>
                                            <i className="icon-subform-next" />
                                          </div>
                                        </div>
                                        <div className="textCont">
                                          <p title={val2.desc}>{val2.desc}</p>
                                        </div>
                                      </div>
                                      <div className="urlBox">
                                        <div className="opBtn">
                                          <div
                                            onClick={this.installApp(val2)}
                                            className="installBtn"
                                          >
                                            <i className="icon-app-install" />
                                            <span>
                                              {React.language("app.install")}
                                            </span>
                                          </div>
                                          {!!val2.url && (
                                            <div
                                              onClick={this.previewSkip(
                                                val2.url
                                              )}
                                              className="previewBtn"
                                            >
                                              <i className="icon-bsy-passwordShow" />
                                              <span>
                                                {React.language("preview")}
                                              </span>
                                            </div>
                                          )}
                                        </div>
                                        <div className="numDetail">
                                          <span>
                                            {React.language("companies.use", {
                                              installnum: val2.num,
                                            })}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </li>
                                );
                              })
                            : val1.tpl_list.map((val2) => {
                                return (
                                  searchMenuId === val.id && (
                                    <li>
                                      <div
                                        className="itemLi"
                                        onClick={this.installApp(val2)}
                                      >
                                        <div className="textBox">
                                          <div className="titleCont">
                                            <div
                                              className={
                                                "icon-backgroup color-cover-" +
                                                val2.icon.style_color
                                              }
                                            >
                                              <div
                                                className={
                                                  "imgbg-bby-app imgbg-bby-app-" +
                                                  val2.icon.style_icon
                                                }
                                              />
                                            </div>
                                            <h2 title={val2.title}>
                                              {val2.title}
                                            </h2>
                                          </div>
                                          <div className="textCont">
                                            <p title={val2.desc}>{val2.desc}</p>
                                          </div>
                                        </div>
                                        <div className="urlBox">
                                          <div className="opBtn">
                                            <div
                                              onClick={this.installApp(val2)}
                                              className="installBtn"
                                            >
                                              <i className="icon-app-install" />
                                              <span>
                                                {React.language("app.install")}
                                              </span>
                                            </div>
                                            {!!val2.url && (
                                              <div
                                                onClick={this.previewSkip(
                                                  val2.url
                                                )}
                                                className="previewBtn"
                                              >
                                                <i className="icon-bsy-passwordShow" />
                                                <span>
                                                  {React.language("preview")}
                                                </span>
                                              </div>
                                            )}
                                          </div>
                                          <div className="numDetail">
                                            <span>
                                              {React.language("companies.use", {
                                                installnum: val2.num,
                                              })}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </li>
                                  )
                                );
                              });
                        });
                      })}
                    </ul>
                  </div>
                </div>
              ) : (
                <div className="solution-cont">
                  <div id="sub-menu">
                    <ul id="subMenu">
                      <li
                        className={childrenMenuId === 0 ? "active" : ""}
                        onClick={this.childrenMenuSwitch(0)}
                      >
                        {React.language("all")}
                      </li>
                      {list.length > 0 &&
                        list.map((val, key) => {
                          return (
                            menuId === val.id &&
                            val.childs.map((val1) => {
                              return (
                                <li
                                  onClick={this.childrenMenuSwitch(val1.id)}
                                  className=""
                                >
                                  {val1.title}
                                </li>
                              );
                            })
                          );
                        })}
                    </ul>
                    <div className="menuMore" style={{ display: "none" }}>
                      <div className="moreBtn">
                        <span>{React.language("more")}</span>
                        <i className="bs-icon-iconbofang2" />
                      </div>
                      <div className="moreList">
                        {list.length > 0 &&
                          list.map((val, key) => {
                            return (
                              menuId === val.id &&
                              val.childs.map((val1) => {
                                return <li className="item">{val1.title}</li>;
                              })
                            );
                          })}
                      </div>
                    </div>
                  </div>
                  <div id="solutionCont">
                    <div className="appLists">
                      {list.length > 0 &&
                        list.map((val, key) => {
                          return menuId === val.id && val.childs.length > 0
                            ? val.childs.map((val1) => {
                                return childrenMenuId === 0 ? (
                                  <div className="item">
                                    <div className="title">
                                      <h2>{val1.title}</h2>
                                    </div>
                                    <div className="itemList">
                                      <ul>
                                        {val1.tpl_list.length > 0 &&
                                          val1.tpl_list.map((val2) => {
                                            return (
                                              <li>
                                                <div
                                                  className="itemLi"
                                                  onClick={this.installApp(
                                                    val2
                                                  )}
                                                >
                                                  <div className="textBox">
                                                    <div className="titleCont">
                                                      <div
                                                        className={
                                                          "icon-backgroup color-cover-" +
                                                          val2.icon.style_color
                                                        }
                                                      >
                                                        <div
                                                          className={
                                                            "imgbg-bby-app imgbg-bby-app-" +
                                                            val2.icon.style_icon
                                                          }
                                                        />
                                                      </div>
                                                      <h2 title={val2.title}>
                                                        {val2.title}
                                                      </h2>
                                                    </div>
                                                    <div className="textCont">
                                                      <p title={val2.desc}>
                                                        {val2.desc}
                                                      </p>
                                                    </div>
                                                  </div>
                                                  <div className="urlBox">
                                                    <div className="opBtn">
                                                      <div
                                                        onClick={this.installApp(
                                                          val2
                                                        )}
                                                        className="installBtn"
                                                      >
                                                        <i className="icon-app-install" />
                                                        <span>
                                                          {React.language(
                                                            "app.install"
                                                          )}
                                                        </span>
                                                      </div>
                                                      {!!val2.url && (
                                                        <div
                                                          onClick={this.previewSkip(
                                                            val2.url
                                                          )}
                                                          className="previewBtn"
                                                        >
                                                          <i className="icon-bsy-passwordShow" />
                                                          <span>
                                                            {React.language(
                                                              "preview"
                                                            )}
                                                          </span>
                                                        </div>
                                                      )}
                                                    </div>
                                                    <div className="numDetail">
                                                      <span>
                                                        {React.language(
                                                          "companies.use",
                                                          {
                                                            installnum:
                                                              val2.num,
                                                          }
                                                        )}
                                                      </span>
                                                    </div>
                                                  </div>
                                                </div>
                                              </li>
                                            );
                                          })}
                                      </ul>
                                      {val1.tpl_list.length <= 0 && (
                                        <div className="listIsEmpty">
                                          {React.language("speedy.item.empty")}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                ) : (
                                  val1.id === childrenMenuId && (
                                    <div className="item">
                                      <div className="title">
                                        <h2>{val1.title}</h2>
                                      </div>
                                      <div className="itemList">
                                        <ul>
                                          {val1.tpl_list.length > 0 &&
                                            val1.tpl_list.map((val2) => {
                                              return (
                                                <li>
                                                  <div
                                                    className="itemLi"
                                                    onClick={this.installApp(
                                                      val2
                                                    )}
                                                  >
                                                    <div className="textBox">
                                                      <div className="titleCont">
                                                        <div
                                                          className={
                                                            "icon-backgroup color-cover-" +
                                                            val2.icon
                                                              .style_color
                                                          }
                                                        >
                                                          <div
                                                            className={
                                                              "imgbg-bby-app imgbg-bby-app-" +
                                                              val2.icon
                                                                .style_icon
                                                            }
                                                          />
                                                        </div>
                                                        <h2 title={val2.title}>
                                                          {val2.title}
                                                        </h2>
                                                      </div>
                                                      <div className="textCont">
                                                        <p title={val2.desc}>
                                                          {val2.desc}
                                                        </p>
                                                      </div>
                                                    </div>
                                                    <div className="urlBox">
                                                      <div className="opBtn">
                                                        <div
                                                          onClick={this.installApp(
                                                            val2
                                                          )}
                                                          className="installBtn"
                                                        >
                                                          <i className="icon-app-install" />
                                                          <span>
                                                            {React.language(
                                                              "app.install"
                                                            )}
                                                          </span>
                                                        </div>
                                                        {!!val2.url && (
                                                          <div
                                                            onClick={this.previewSkip(
                                                              val2.url
                                                            )}
                                                            className="previewBtn"
                                                          >
                                                            <i className="icon-bsy-passwordShow" />
                                                            <span>
                                                              {React.language(
                                                                "preview"
                                                              )}
                                                            </span>
                                                          </div>
                                                        )}
                                                      </div>
                                                      <div className="numDetail">
                                                        <span>
                                                          {React.language(
                                                            "companies.use",
                                                            {
                                                              installnum:
                                                                val2.num,
                                                            }
                                                          )}
                                                        </span>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </li>
                                              );
                                            })}
                                        </ul>
                                        {val1.tpl_list.length <= 0 && (
                                          <div className="listIsEmpty">
                                            {React.language(
                                              "speedy.item.empty"
                                            )}
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  )
                                );
                              })
                            : menuId === val.id && (
                                <div className="appList-empty">
                                  {React.language("app.store.list.empty")}
                                </div>
                              );
                        })}
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="mask-cont" onClick={this.closeMenu} />
          </div>
        </div>
        {document.body.offsetWidth >= 1000 && appNum === 0 && step <= 2 && (
          <div className="appStoreGuide">
            {step === 1 && (
              <div className="guide-content step1">
                <div className="click-guide">
                  <div
                    className="app-blank app-create-item"
                    onClick={this.createApp}
                  >
                    <div
                      className="background"
                      style={{
                        backgroundImage:
                          "url(" +
                          window.rootDirectroy +
                          "/template/formreport/static/css/resources/images/blueBG.png)",
                      }}
                    >
                      <span>{React.language("app.create.empty")}</span>
                    </div>
                  </div>
                </div>
                <div
                  className="guide-bg"
                  style={{
                    backgroundImage:
                      "url(" +
                      window.rootDirectroy +
                      "/template/formreport/static/css/resources/images/img_appstore_guide1@2x.png)",
                  }}
                >
                  <div className="step-text">
                    <div
                      className="text-title"
                      dangerouslySetInnerHTML={{
                        __html: React.language("appstore.guide.step1.title"),
                      }}
                    />
                    <div
                      className="text-desc"
                      dangerouslySetInnerHTML={{
                        __html: React.language("appstore.guide.step1.desc"),
                      }}
                    />
                  </div>
                  <div className="step-btn">
                    <div className="pass-btn" onClick={this.guideStep(3)}>
                      {React.language("skip")}
                    </div>
                    <div className="next-btn" onClick={this.guideStep(2)}>
                      {React.language("nextStep")}
                    </div>
                  </div>
                </div>
              </div>
            )}
            {step === 2 && (
              <div className="guide-content step2">
                <div className="click-guide">
                  <div
                    className="app-custom app-create-item"
                    onClick={this.toApp}
                  >
                    <div
                      className="background"
                      style={{
                        backgroundImage:
                          "url(" +
                          window.rootDirectroy +
                          "/template/formreport/static/css/resources/images/greenBG.png)",
                      }}
                    >
                      <span>{React.language("select.app.module")}</span>
                    </div>
                  </div>
                </div>
                <div
                  className="guide-bg"
                  style={{
                    backgroundImage:
                      "url(" +
                      window.rootDirectroy +
                      "/template/formreport/static/css/resources/images/img_appstore_guide2@2x.png)",
                  }}
                >
                  <div className="step-text">
                    <div
                      className="text-title"
                      dangerouslySetInnerHTML={{
                        __html: React.language("appstore.guide.step1.title"),
                      }}
                    />
                    <div
                      className="text-desc"
                      dangerouslySetInnerHTML={{
                        __html: React.language("appstore.guide.step2.desc"),
                      }}
                    />
                  </div>
                  <div className="step-btn">
                    <div className="next-btn" onClick={this.guideStep(3)}>
                      {React.language("m.reset.password.success.ok")}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(BsyAppStore);
